import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import firebaseStore from '@client/stores/firebaseStore';
import modalStore, { ModalOption } from '@client/stores/modalStore';
import LoginForm from '@client/component/LoginForm';
import { CommonLink } from '@client/component/CommonLink';
import { Modal } from './Modal';

/**
 * 로그인 모달 (공유)
 * - 로그인 폼을 모달로 표시
 * - 로그인 성공 시 true 반환
 * - 앱별 로그인 후 처리(예: 추가 정보 입력)가 필요한 경우 앱 전용 LoginModal을 사용
 */
const LoginModal = observer(({ modalId, option }: { modalId: string; option: ModalOption }) => {
    const onSuccess = async () => {
        modalStore.setReturnValue(modalId, true);

        _.delay(async () => {
            await modalStore.close(modalId);
        }, 300);
    };

    return (
        <Modal.Dialog modalId={modalId}>
            <Modal.BodyScroll>
                <div className="pt-11 pb-13">
                    <LoginForm onSuccess={onSuccess} />
                </div>
                <div className="text-base-content/50 text-[12px] leading-normal">
                    로그인하면 이용약관 및 개인정보처리방침에 동의하게 됩니다.
                </div>
            </Modal.BodyScroll>
            {!firebaseStore.isLoggingIn && <Modal.CloseXButton />}
        </Modal.Dialog>
    );
});

export default LoginModal;
